import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import deviceAppearanceColors from '../consts/device/settings/deviceAppearanceColors';
import settingNames from '../consts/device/settings/settingNames';
import milestoneTypes from '../consts/loyalty/milestoneTypes';
import loyaltyQueueService from '../services/loyalty/loyaltyQueueService';
import loyaltyService from '../services/loyalty/loyaltyService';
import {selectIsAuthorized} from '../state/selectors/auth';
import {selectIsRetail} from '../state/selectors/global';
import {
    selectCurrentDusn,
    selectDeviceCustomUI,
    selectIsDeviceUpdateSettingInProgress,
} from '../state/selectors/iotDevices';
import {selectIsUserSessionInitialized} from '../state/selectors/session';

const useLoyaltyData = () => {
    const isUserAuthorized = useSelector(selectIsAuthorized);
    const isRetail = useSelector(selectIsRetail);
    const isUserSessionInitialized = useSelector(selectIsUserSessionInitialized);
    const dusn = useSelector(selectCurrentDusn);
    const customUI = useSelector(selectDeviceCustomUI(dusn));
    const isCustomUiInProgress = useSelector(selectIsDeviceUpdateSettingInProgress(dusn, settingNames.CUSTOM_UI));

    const initBadgeQueue = async () => {
        await loyaltyQueueService.initQueue();
    };

    const completeChangeColorMilestone = async () => {
        await loyaltyService.completeMilestone(milestoneTypes.CHANGE_DEVICE_COLOR);
    };

    useEffect(() => {
        if (isUserAuthorized && isUserSessionInitialized && !isRetail) {
            initBadgeQueue();
        }
    }, [isUserAuthorized, isUserSessionInitialized]);

    // NOTE: Complete the CHANGE_DEVICE_COLOR milestone if the value is different from the default.
    useEffect(() => {
        const DEFAULT = deviceAppearanceColors.WHITE;

        if (customUI && DEFAULT !== customUI && !isCustomUiInProgress && isUserAuthorized && isUserSessionInitialized) {
            completeChangeColorMilestone();
        }
    }, [customUI, isCustomUiInProgress, isUserAuthorized, isUserSessionInitialized]);
};

export default useLoyaltyData;
